import { format, isAfter, parseISO } from "date-fns";

function toFriendlyDatetime(date: number | Date) {
  try {
    const formattedDate = format(date, "PPP, p");

    return formattedDate;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return "Invalid date";
  }
}

function toFriendlyDate(date: number | Date | string) {
  try {
    const d = typeof date === "string" ? parseISO(date) : date;
    const formattedDate = format(d, "PPP");

    return formattedDate;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return "Invalid date";
  }
}

function toFriendlyDatetimeShort(date: number | Date | string | undefined) {
  try {
    if (date === undefined) return "*";

    const formattedDate = format(date, "PPpp");

    return formattedDate;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return "Invalid date";
  }
}

function toLocalDateISOString(date: Date | number | string) {
  try {
    const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss'Z'");

    return formattedDate;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return new Date().toISOString();
  }
}

function parseDateString(dateString: string): Date {
  try {
    const parsedDate = parseISO(dateString);

    return parsedDate;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return new Date();
  }
}

function isDateGreaterThan(date1: Date | number | string, date2: Date | number | string): boolean {
  const parsedDate1 = typeof date1 === "string" ? parseISO(date1) : date1;
  const parsedDate2 = typeof date2 === "string" ? parseISO(date2) : date2;

  return isAfter(parsedDate1, parsedDate2);
}

const e = {
  toLocalDateISOString,
  parseDateString,
  toFriendlyDatetime,
  toFriendlyDate,
  isDateGreaterThan,
  toFriendlyDatetimeShort,
};

export default e;
